import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useGetShopEmbedHtmlSuspense from "@babackapp/private-api-client/client/use-get-embed-content";
import type { EmbedContent } from "@babackapp/private-api-client/generated/schema";
import { injectEmbedScript } from "./inject-embed-script";

export default function EmbedPage() {
  const [searchParams] = useSearchParams();
  const shopifyUrl = searchParams.get("shop");

  if (!shopifyUrl) {
    throw new Error("shop param is required");
  }

  const { data } = useGetShopEmbedHtmlSuspense(shopifyUrl, true);
  const shopId = data.shopId;

  if (!shopId) return null;

  return (
    <>
      <EmbedScriptRunner embedData={data} shopId={shopId} />
      <div dangerouslySetInnerHTML={{ __html: data.html }} />
    </>
  );
}

function EmbedScriptRunner({
  embedData,
  shopId,
}: {
  embedData: EmbedContent;
  shopId: string;
}) {
  useEffect(() => {
    injectEmbedScript(embedData, shopId);
  }, [embedData, shopId]);

  return null;
}
